var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconLoader,{tag:"component",style:(_vm.iconStyle),attrs:{"fill":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }